(function (global) {
  'use strict';

  var prefix = 'plumme:';
  var startedAt = global.performance && Number.isFinite(global.performance.timeOrigin)
    ? global.performance.timeOrigin
    : Date.now();
  var stages = Object.create(null);

  function now() {
    return global.performance && typeof global.performance.now === 'function'
      ? global.performance.now()
      : Date.now() - startedAt;
  }

  function mark(name, detail) {
    var key = String(name || '').trim();
    if (!key) return 0;
    if (stages[key]) return stages[key].at;
    var at = Math.round(now() * 10) / 10;
    stages[key] = { at: at, detail: detail && typeof detail === 'object' ? detail : undefined };
    try { global.performance && global.performance.mark(prefix + key); } catch (error) {}
    try {
      global.dispatchEvent(new CustomEvent('plumme-startup-performance', {
        detail: { name: key, at: at },
      }));
    } catch (error) {}
    return at;
  }

  function measure(name, from, to) {
    var start = stages[from] && stages[from].at;
    var end = stages[to] && stages[to].at;
    if (!Number.isFinite(start) || !Number.isFinite(end)) return null;
    var duration = Math.round((end - start) * 10) / 10;
    try { global.performance && global.performance.measure(prefix + name, prefix + from, prefix + to); } catch (error) {}
    return duration;
  }

  function snapshot() {
    var result = {};
    Object.keys(stages).forEach(function (key) { result[key] = { ...stages[key] }; });
    return result;
  }

  function report() {
    return {
      stages: snapshot(),
      totals: {
        toReactMounted: measure('to-react-mounted', 'html-start', 'react-mounted'),
        toAuthResolved: measure('to-auth-resolved', 'html-start', 'auth-resolved'),
        toStateReady: measure('to-state-ready', 'html-start', 'state-ready'),
        toInteractive: measure('to-interactive', 'html-start', 'interactive'),
      },
    };
  }

  global.PlummeStartupPerformance = Object.freeze({ mark: mark, measure: measure, snapshot: snapshot, report: report });
  mark('html-start');
})(window);
